import { AdminPageHeader, AdminPageShell } from '@/components/patterns/admin-page'
import StripePaymentMethods from '@/components/stripe-connect/StripePaymentMethods'
import { canUseStripeConnectOnboarding } from '@/components/stripe-connect/stripeConnectStatus'
import { stripeOnboardingLink } from '@/lib/stripe-financial-routes'
import { assertNotSalesDemoOrganization } from '@/lib/services/sales-demos/sales-demos.guard'
import { stripeConnectQueries } from '@/lib/services/stripe-connect/stripe-connect.query'
import { createFileRoute, notFound, redirect, useParams } from '@tanstack/react-router'
import { CreditCard } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/settings/stripe/payment-methods')({
  component: PaymentMethodsPage,
  loader: async ({ context, params }) => {
    if (!context.ability.can('edit', 'stripe-account')) throw notFound()
    await assertNotSalesDemoOrganization(context.queryClient, params.orgId)
    const status = await context.queryClient.fetchQuery(
      stripeConnectQueries.status({ organizationId: params.orgId })
    )
    if (canUseStripeConnectOnboarding(status?.status))
      throw redirect(stripeOnboardingLink(params.orgId))
  },
})

function PaymentMethodsPage() {
  const { orgId } = useParams({ strict: false })
  return (
    <AdminPageShell maxWidth="content">
      <AdminPageHeader
        icon={CreditCard}
        title="Payment methods"
        description="Manage buy now, pay later options for your payment account."
      />
      <StripePaymentMethods key={orgId} organizationId={orgId} />
    </AdminPageShell>
  )
}
